import { useTranslation } from 'react-i18next'
import { useTemplateMeals } from './useTemplateMeals'
import { useAddTemplate } from './useAddTemplate'
import { TemplateCard } from './TemplateCard'

export function TemplateList() {
  const { t } = useTranslation('templates')
  const { data: templates, isLoading, isError } = useTemplateMeals()
  const addMutation = useAddTemplate()

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="bg-surface rounded-xl border border-line p-4 h-[72px] animate-pulse"
          />
        ))}
      </div>
    )
  }

  if (isError) {
    return (
      <p className="text-danger text-sm" role="alert">
        {t('list.error')}
      </p>
    )
  }

  if (!templates || templates.length === 0) {
    return <p className="text-muted text-sm">{t('list.empty')}</p>
  }

  // Group by category
  const categories = [...new Set(templates.map((t) => t.category))]

  return (
    <div className="space-y-6">
      {addMutation.isError && (
        <p className="text-danger text-sm" role="alert">
          {t('list.addError')}
        </p>
      )}
      {categories.map((category) => (
        <section key={category} aria-label={category}>
          <h2 className="text-sm font-semibold text-muted uppercase tracking-wide mb-2">
            {category}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {templates
              .filter((t) => t.category === category)
              .map((template) => (
                <TemplateCard
                  key={template.id}
                  template={template}
                  onAdd={(id) => addMutation.mutate(id)}
                  isPending={addMutation.isPending && addMutation.variables === template.id}
                />
              ))}
          </div>
        </section>
      ))}
    </div>
  )
}
